import { SubTranRecordModel } from "./sub-tran-record.model"

export class SaveSubTranModel {
    SubTran: SubTranRecordModel[]
    intTotal: number

    constructor(
        SubTran: SubTranRecordModel[],
        intTotal: number
    ) {
        this.SubTran = SubTran
        this.intTotal = intTotal
    }
}